var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.657,
    height: 70.229,
    viewBox: "0 0 78.657 70.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.692,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 78.657,
    height: 70.229,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1.405,56.183H28.947L27.082,61.8h-.4a4.214,4.214,0,0,0,0,8.428H51.969a4.214,4.214,0,1,0,0-8.428h-.394l-1.866-5.619H77.252a1.4,1.4,0,0,0,1.405-1.4V1.405A1.406,1.406,0,0,0,77.252,0H1.405A1.406,1.406,0,0,0,0,1.405V54.779a1.4,1.4,0,0,0,1.405,1.4m51.969,9.833a1.406,1.406,0,0,1-1.405,1.405H26.686a1.405,1.405,0,0,1,0-2.81H51.969a1.406,1.406,0,0,1,1.405,1.405M48.612,61.8H30.045l1.866-5.619H46.746Zm27.234-8.428H2.809V44.947H75.847Zm0-11.236H2.809V2.81H75.847Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M42.858,12.541H65.333a1.406,1.406,0,0,0,1.405-1.405V5.518a1.406,1.406,0,0,0-1.405-1.405H42.858a1.4,1.4,0,0,0-1.4,1.405v5.617a1.4,1.4,0,0,0,1.4,1.405m1.405-5.619H63.927V9.73H44.264ZM42.858,23.777H65.333a1.4,1.4,0,0,0,1.405-1.4V16.754a1.406,1.406,0,0,0-1.405-1.405H42.858a1.4,1.4,0,0,0-1.4,1.405v5.619a1.4,1.4,0,0,0,1.4,1.4m1.405-5.617H63.927v2.809H44.264ZM42.858,35.015H65.333a1.406,1.406,0,0,0,1.405-1.405V27.991a1.4,1.4,0,0,0-1.405-1.4H42.858a1.4,1.4,0,0,0-1.4,1.4V33.61a1.4,1.4,0,0,0,1.4,1.405M44.264,29.4H63.927V32.2H44.264ZM17.577,35.015A12.644,12.644,0,0,0,30.219,22.373a1.406,1.406,0,0,0-1.405-1.405H18.981V11.135a1.4,1.4,0,0,0-1.4-1.4,12.641,12.641,0,1,0,0,25.283M16.172,12.636v9.737a1.4,1.4,0,0,0,1.405,1.4h9.735A9.833,9.833,0,1,1,16.172,12.636",
    transform: "translate(3.492 2.91)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M16.211,18.159H27.449a1.4,1.4,0,0,0,1.4-1.4A12.644,12.644,0,0,0,16.211,4.114a1.4,1.4,0,0,0-1.4,1.4V16.755a1.4,1.4,0,0,0,1.4,1.4M17.617,7.018a9.837,9.837,0,0,1,8.332,8.332H17.617Z",
    transform: "translate(10.475 2.91)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactIcon);
export default __webpack_public_path__ + "static/media/impact_icon.c56489146f785bde83b70b4d72916db8.svg";
export { ForwardRef as ReactComponent };